<script lang="ts">
  import type { Facility, FacilityValidation } from "../../helpers/types";
  import Checkbox from "../atoms/Checkbox.svelte";
  import ErrorText from "../atoms/ErrorText.svelte";
  import Heading from "../atoms/Heading.svelte";
  import LockedTextInput from "../atoms/LockedTextInput.svelte";
  import PnrInformation from "../atoms/PnrInformation.svelte";
  import Text from "../atoms/Text.svelte";
  import TextInput from "../atoms/TextInput.svelte";

  interface Props {
    facility: Facility;
    facilityValidator: FacilityValidation;
    hasPressedContinue?: boolean;
  }

  let {
    facility = $bindable(),
    facilityValidator = $bindable(),
    hasPressedContinue = false,
  }: Props = $props();
</script>

<Heading variant="primary" class="mb-2" margin={false}>Vad vill du ha hjälp med?</Heading>
<div class="flex flex-col space-y-2">
  {#if facility.powerOfAttorney === undefined && hasPressedContinue}
    <ErrorText>Välj ett alternativ</ErrorText>
  {/if}
  <Checkbox
    onClick={() => (facility.powerOfAttorney = false)}
    checked={facility.powerOfAttorney === false}
    type="radio">Teckna elhandelsavtal (jag har redan skaffat ett nytt elnätsavtal)</Checkbox
  >
  {#if facility.powerOfAttorney === false}
    <div class="fade-in">
      <PnrInformation>
        <p class="text-base text-Neutral900">
          Viktigt att tänka på: Det måste vara samma person som står på elnätsavtalet som tecknar
          detta elhandelsavtal. När du flyttar, kom ihåg att säga upp elnätsavtalet på den gamla
          adressen.
        </p>
      </PnrInformation>
      <div class="ml-10 mt-2">
        <div>
          {#if (facilityValidator.errors.facilityId && facility?.facilityId && facility?.facilityId.toString().length >= 12) || (!facility.facilityId && hasPressedContinue)}
            <ErrorText>Ogiltigt anläggnings-ID (735999xxxxxxxxxxxx)</ErrorText>
          {:else}
            <Text variant="primary">Anläggnings-ID (735999xxxxxxxxxxxx)</Text>
          {/if}
          <Text
            >18 siffror, finns på elmätaren och fakturan. Kontakta din nya elnätsleverantör,
            tidigare ägare eller hyresvärd för att få dessa uppgifter.</Text
          >
          <LockedTextInput
            required={!facility.powerOfAttorney}
            inputPadding="pl-17"
            {hasPressedContinue}
            error={(facilityValidator.errors.facilityId &&
              facility?.facilityId &&
              facility?.facilityId.toString().length >= 12) ||
              (!facility.facilityId && hasPressedContinue)}
            max={"19"}
            bind:value={facility.facilityId}
            lockedValue="735999"
          />
        </div>
        <div class="mt-3">
          {#if (facilityValidator.errors.areaId && facility?.areaId && facility?.areaId.length >= 3) || (!facility.areaId && hasPressedContinue)}
            <ErrorText>Ogiltigt områdes-ID</ErrorText>
          {:else}
            <Text variant="primary">Områdes-ID</Text>
          {/if}
          <Text
            >Tre bokstäver. Kontakta tidigare ägare eller hyresvärd för att få dessa uppgifter.</Text
          >
          <TextInput
            error={(facilityValidator.errors.areaId &&
              facility?.areaId &&
              facility?.areaId.length >= 3) ||
              (!facility.areaId && hasPressedContinue)}
            {hasPressedContinue}
            max={"3"}
            bind:value={facility.areaId}
          />
        </div>
      </div>
    </div>
  {/if}
  <Checkbox
    onClick={() => (facility.powerOfAttorney = true)}
    checked={facility.powerOfAttorney === true}
    type="radio">Låt Skellefteå Kraft sköta allt som rör bytet</Checkbox
  >
  {#if facility.powerOfAttorney === true}
    <div class="ml-10 fade-in">
      <Text
        >Vid flytt ger jag Skellefteå Kraft, eller den Skellefteå Kraft förordnar i sitt ställe
        fullmakt att i mitt namn teckna ett elnätsavtal. Fullmakten omfattar även rätt att inhämta
        uppgifter från mitt elnätsföretag och mitt elhandelsföretag, samt vid behov säga upp mitt
        nuvarande elavtal. Fullmakten är giltig till dess att din flytt är genomförd och avtalet
        registrerat. Fullmakten är giltig 3 månader fr om registeringsdatum och är endast giltig vid
        ett byte.
      </Text>
      <Text>
        Ditt nya elavtal hos Skellefteå Kraft börjar gälla så snart som möjligt eller när det
        befintliga elavtalet löper ut.
      </Text>
    </div>
  {/if}
</div>
